import React, { useState } from 'react';
import {
  Container,
  CssBaseline,
  TextField,
  Button,
} from '@mui/material';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom'; 
import './styles.css';
import { getCurrentUser, isAdmin, login } from '../../services/authService';
import { ReactComponent as Logo } from '../../assets/unimates_logo.svg';

function Login() {
  const navigate = useNavigate(); 
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleLogin = async () => {
    const { username, password } = formData;
    setLoading(true);

    const success = await login(username, password);

    setLoading(false);

    if (success) {
      const user = getCurrentUser();

      if (isAdmin(user)) {
        console.log("dashboard-admin");
        navigate('/dashboard-admin', { replace: true }); 
      } else {
        console.log("universities-dashboard");
        navigate('/universities-dashboard', { replace: true }); 
      }
    } else {
      toast.error('Nom d\'utilisateur ou mot de passe incorrect', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className="login-container">
      <Logo/>
       
        <form className="form">
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            id="username"
            label="Username"
            name="username"
            autoComplete="username"
            autoFocus
            value={formData.username}
            onChange={handleInputChange}
          />
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={formData.password}
            onChange={handleInputChange}
          />
          <Button
            fullWidth
            style={{ backgroundColor: '#FC6258' }}
            variant="contained"
            color="primary"
            className="submit"
            onClick={handleLogin}
          >
            Se connecter
          </Button>
        </form>
      </div>
      <ToastContainer />
      {loading && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}
    </Container>
  );
}

export default Login;
